import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span>&copy; 2018-{new Date().getUTCFullYear()} <a href="http://www.afbn.us">Armed Forces Benefits Network</a></span>
        <span className="ml-auto">Powered by <a href="http://www.smithos.net">Smith Operating Solutions, LLC</a></span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js